var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-header-title"},[_vm._v(_vm._s(_vm.$t('Settlement of partners')))]),_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":'/partnersSettlements/create?partner_id=' + _vm.$route.params.id}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('Addition'))+" ")])],1),_c('indexTable',{attrs:{"searchText":_vm.$t('Search for a process'),"emptyTableText":_vm.$t('There are currently no settlements'),"filter":{ partner_id: _vm.$route.params.id },"emptyTableSubText":_vm.$t('Try adding some and try again'),"withoutCard":true,"cloumns":[
        {
          column: 'code',
          title: _vm.$t('Operation'),
          type: 'mainLink',
          sort: true
        },
        {
          column: 'safe_id',
          title: _vm.$t('Project'),
          type: 'link',
          to: 'project',
          sort: true,
          link: true
        },
        {
          column: 'date',
          title: _vm.$t('Date'),
          type: 'text',
          sort: true
        },
        {
          column: 'total',
          title: _vm.$t('Cost'),
          type: 'text',
          sort: true
        },
        {
          column: 'description',
          title: _vm.$t('That about'),
          type: 'text',
          sort: true
        },
        {
          column: 'options',
          title: _vm.$t('Settings'),
          type: 'options',
          options: [
            { name: 'show' },
            {
              name: 'edit',
              role: _vm.$checkRole('partners_settlements_edit')
            },
            {
              name: 'delete',
              role: _vm.$checkRole('partners_settlements_delete')
            }
          ]
        }
      ],"deleteText":{
        attention: _vm.$t('Attention'),
        areYouReallySureToDeleteTheItem: _vm.$t('Are you really sure to delete the item'),
        close: _vm.$t('Close'),
        confirm: _vm.$t('Confirm'),
        loading: _vm.$t('Loading')
      }}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }